<template>
  <v-container fluid>
    <component :is="routeItems[activeRoute].component" class=""></component>
  </v-container>
</template>

<script>
import { authRoute } from '@/router/routeRole'
// 
import TestUploadForm from '@/views/examples/TestUploadForm'
import TestElementsForm from '@/views/examples/TestElementsForm'
import TestCKEditorForm from '@/views/examples/TestCKEditorForm'

export default {
  name: 'examplesTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'testElementsForm',
          route: 'testElementsForm',
          component: TestElementsForm,
        },
        {
          title: 'testUploadForm',
          route: 'testUploadForm',
          component: TestUploadForm,
        },
        {
          title: 'testCKEditorForm',
          route: 'testCKEditorForm',
          component: TestCKEditorForm,
        },
      ]
    },
    tabItems() {
      return this.routeItems.filter((item) => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function (item, index) {
          return this.$route.matched.find((element) => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function (item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
